import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatDuration, intervalToDuration } from "date-fns";
import { addMilliseconds } from "date-fns/esm";
import { Box, Text } from "grommet";
import * as React from "react";
import GenericErrorBoundary from "../general/GenericErrorBoundary";
import { StatViewModel } from "./StatsStore";
import { MatchStatViewModel } from "../matches/MatchesStore";

import { Stat, StatColor, StatIcon } from "./StatIcon";

export const StatValue = (stat: StatViewModel, value: number) => {
    if (stat.type === "Time") {
        let duration = value;
        let items = [] as string[];

        if (duration > 31557600000) {
            items.push(`${Math.floor(duration / 31557600000)}Y`);
            duration = duration % 31557600000;
        }
        if (duration > 2629800000) {
            items.push(`${Math.floor(duration / 2629800000)}M`);
            duration = duration % 2629800000;
        }
        if (duration > 86400000) {
            items.push(`${Math.floor(duration / 86400000)}D`);
            duration = duration % 86400000;
        }
        if (duration > 3600000) {
            items.push(`${Math.floor(duration / 3600000)}h`);
            duration = duration % 3600000;
        }
        if (duration > 60000) {
            items.push(`${Math.floor(duration / 60000)}m`);
            duration = duration % 60000;
        }
        if (duration > 0) {
            items.push(`${duration / 1000}s`);
            duration = duration % 1000;
        }

        return items.length == 0 ? "--" : items.join(" ");
    } else {
        return value;
    }
};

export const RenderStat = ({ stat, value, disabled, onClick }: { stat: StatViewModel; value: number; disabled: boolean; onClick: any }) => {
    let color = StatColor(stat);
    const [showName, setShowName] = React.useState(false);

    return stat ? (
        <Text onMouseOver={() => setShowName(true)} onMouseLeave={() => setShowName(false)}>
            <Stat stat={stat} disabled={disabled} onClick={onClick}>
                {showName && <Text>{stat.name}</Text>}
                {StatValue(stat, value)}
            </Stat>
        </Text>
    ) : (
        <></>
    );
};
